import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginForm from './components/LoginForm';
import RegisterForm from './components/RegisterForm';
import ForgotPassword from './components/ForgotPassword';
import Dashboard from './components/Dashboard';
import AgentLayout from './components/AgentLayout';
import AgentDashboard from './components/AgentDashboard';
import SupportLayout from './components/SupportLayout';
import SupportDashboard from './components/support/SupportDashboard';
import AdminLayout from './components/AdminLayout';
import AdminDashboard from './components/admin/AdminDashboard';
import AgentSearchHotel from './components/agent/AgentSearchHotel';
import HotelDetailsPage from './components/agent/HotelDetailsPage';
import AgentCustomerDetailsPage from './components/agent/AgentCustomerDetailsPage';
import AgentPassengerDetailsPage from './components/agent/AgentPassengerDetailsPage';
import SupportSearchHotel from './components/support/SupportSearchHotel';
import SupportManageAgents from './components/support/SupportManageAgents';
import SupportTickets from './components/support/SupportTickets';
import SupportTicketDetails from './components/support/SupportTicketDetails';
import SupportTokenRecharge from './components/support/SupportTokenRecharge';
import SupportHotelBookings from './components/support/SupportHotelBookings';
import SupportBookingDetails from './components/support/SupportBookingDetails';
import SupportBookingCancellation from './components/support/SupportBookingCancellation';
import SupportCancellationDetails from './components/support/SupportCancellationDetails';
import SupportPaymentInfo from './components/support/SupportPaymentInfo';
import SupportManualPayment from './components/support/SupportManualPayment';
import SupportRefundInfo from './components/support/SupportRefundInfo';
import SupportMyTickets from './components/support/SupportMyTickets';
import SupportManageCustomers from './components/support/SupportManageCustomers';
import SupportVirtualAccount from './components/support/SupportVirtualAccount';
import SupportAgentDetails from './components/support/SupportAgentDetails';
import AdminSearchHotel from './components/admin/AdminSearchHotel';
import AdminAgentsManagement from './components/admin/AdminAgentsManagement';
import AdminAgentDetails from './components/admin/AdminAgentDetails';
import AdminSupportManagement from './components/admin/AdminSupportManagement';
import AdminSupportDetails from './components/admin/AdminSupportDetails';
import AdminAgentTickets from './components/admin/AdminAgentTickets';
import AdminSupportTickets from './components/admin/AdminSupportTickets';
import AdminSupportTicketDetails from './components/admin/AdminSupportTicketDetails';
import AdminMySupportTickets from './components/admin/AdminMySupportTickets';
import AdminMySupportTicketDetails from './components/admin/AdminMySupportTicketDetails';
import AdminBookingDetails from './components/admin/AdminBookingDetails';
import AdminBookingDetailView from './components/admin/AdminBookingDetailView';
import AdminCancellationBooking from './components/admin/AdminCancellationBooking';
import AdminCancellationBookingDetails from './components/admin/AdminCancellationBookingDetails';
import AdminAgentBookingDetails from './components/admin/AdminAgentBookingDetails';
import AdminPaymentInfo from './components/admin/AdminPaymentInfo';
import AdminPaymentInfoDetails from './components/admin/AdminPaymentInfoDetails';
import AdminManualPaymentInfo from './components/admin/AdminManualPaymentInfo';
import AdminManualPaymentDetails from './components/admin/AdminManualPaymentDetails';
import AdminPaymentRefundInfo from './components/admin/AdminPaymentRefundInfo';
import AdminPaymentRefundInfoDetails from './components/admin/AdminPaymentRefundInfoDetails';
import AdminSettings from './components/admin/AdminSettings';
import AdminApiManager from './components/admin/AdminApiManager';
import AdminPlatformSettings from './components/admin/AdminPlatformSettings';
import AdminCancellationPolicySettings from './components/admin/AdminCancellationPolicySettings';
import AdminAddSupportExecutive from './components/admin/AdminAddSupportExecutive';
import AdminAgentTokenRecharge from './components/admin/AdminAgentTokenRecharge';
import AdminAgentBookingHistory from './components/admin/AdminAgentBookingHistory';
import AdminTokenRechargeOperation from './components/admin/AdminTokenRechargeOperation';
import SearchHistory from './components/agent/SearchHistory';
import TokenRecharge from './components/agent/TokenRecharge';
import BookingDetails from './components/agent/BookingDetails';
import CustomerBookingDetail from './components/agent/CustomerBookingDetail';
import BookingCancellationsRoute from './components/agent/BookingCancellationsRoute';
import CancellationDetailRoute from './components/agent/CancellationDetailRoute';
import BookingHistory from './components/agent/BookingHistory';
import PaymentRefundRoute from './components/agent/PaymentRefundRoute';
import ManualPayment from './components/agent/ManualPayment';
import SupportTicket from './components/agent/SupportTicket';
import SupportTicketDetail from './components/agent/SupportTicketDetail';
import TokenHistory from './components/agent/TokenHistory';
import ProtectedRoute from './components/ProtectedRoute';
import authService from './utils/authService';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

import ApiServiceTest from './components/test/ApiServiceTest';
import Home from './pages/Home';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Landing Page */}
          <Route path="/" element={<Home />} />

          {/* Legal Pages */}
          <Route path="/terms-and-conditions" element={<Terms />} />
          <Route path="/privacy-policy" element={<Privacy />} />

          {/* Public Routes */}
          <Route path="/login" element={<LoginForm />} />
          <Route path="/register" element={<RegisterForm />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          
          {/* Protected Agent Routes */}
          <Route path="/agent" element={
            <ProtectedRoute requiredRole="ROLE_AGENT">
              <AgentLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AgentDashboard />} />
            <Route path="dashboard/searchhotel" element={<AgentSearchHotel />} />
            <Route path="dashboard/searchhistory" element={<SearchHistory />} />
            <Route path="dashboard/tokenrecharge" element={<TokenRecharge />} />
            <Route path="dashboard/bookingdetails" element={<BookingDetails />} />
            <Route path="dashboard/booking-details" element={<Navigate to="/agent/dashboard/bookingdetails" replace />} />
            <Route path="dashboard/booking-details/:bookingId" element={<CustomerBookingDetail />} />
            <Route path="dashboard/bookingcancellation" element={<BookingCancellationsRoute />} />
            <Route path="dashboard/booking-cancellation" element={<BookingCancellationsRoute />} />
            <Route path="dashboard/booking-cancellation/:cancellationId" element={<CancellationDetailRoute />} />
            <Route path="dashboard/bookinghistory" element={<BookingHistory />} />
            <Route path="dashboard/paymentinfo" element={<PaymentRefundRoute />} />
            <Route path="dashboard/payment-refund" element={<PaymentRefundRoute />} />
            <Route path="dashboard/manualpayment" element={<ManualPayment />} />
            <Route path="dashboard/manual-payment" element={<ManualPayment />} />
            <Route path="dashboard/supportticket" element={<SupportTicket />} />
            <Route path="dashboard/support-ticket/:ticketId" element={<SupportTicketDetail />} />
            <Route path="dashboard/tokenhistory" element={<TokenHistory />} />
          </Route>

          {/* Test Route */}
          <Route path="/test/api-service" element={<ApiServiceTest />} />

          {/* Standalone Hotel Details Route (No Layout) */}
          <Route path="/agent/dashboard/searchhotel/details/:hotelId" element={
            <ProtectedRoute requiredRole="ROLE_AGENT">
              <HotelDetailsPage />
            </ProtectedRoute>
          } />

          {/* Prebook Routes (No Layout) */}
          <Route path="/agent/dashboard/prebook/customer-detail/:hotelId" element={
            <ProtectedRoute requiredRole="ROLE_AGENT">
              <AgentCustomerDetailsPage />
            </ProtectedRoute>
          } />

          <Route path="/agent/dashboard/prebook/passenger-details" element={
            <ProtectedRoute requiredRole="ROLE_AGENT">
              <AgentPassengerDetailsPage />
            </ProtectedRoute>
          } />

          {/* Protected Support Routes */}
          <Route path="/support" element={
            <ProtectedRoute requiredRole="ROLE_SUPPORT">
              <SupportLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<SupportDashboard />} />
            <Route path="dashboard/search-hotel" element={<SupportSearchHotel />} />
            <Route path="dashboard/searchhotel" element={<SupportSearchHotel />} />
            <Route path="dashboard/account-manager" element={<SupportManageAgents />} />
            <Route path="dashboard/account-manager/details/:id" element={<SupportAgentDetails />} />
            <Route path="dashboard/support-tickets" element={<SupportTickets />} />
            <Route path="dashboard/support-tickets/:id" element={<SupportTicketDetails />} />
            <Route path="dashboard/token-recharge" element={<SupportTokenRecharge />} />
            <Route path="dashboard/booking-details" element={<SupportHotelBookings />} />
            <Route path="dashboard/support/booking/details/:id" element={<SupportBookingDetails />} />
            <Route path="dashboard/cancellation-page-details" element={<SupportBookingCancellation />} />
            <Route path="dashboard/support/cancellation/details/:id" element={<SupportCancellationDetails />} />
            <Route path="dashboard/payment-info" element={<SupportPaymentInfo />} />
            <Route path="dashboard/manual-payment-info" element={<SupportManualPayment />} />
            <Route path="dashboard/refund-info" element={<SupportRefundInfo />} />
            <Route path="dashboard/my-support-tickets" element={<SupportMyTickets />} />
            <Route path="dashboard/manage-customers" element={<SupportManageCustomers />} />
            <Route path="dashboard/add-virtual-account" element={<SupportVirtualAccount />} />
          </Route>

          {/* Protected Admin Routes */}
          <Route path="/admin" element={
            <ProtectedRoute requiredRole="ROLE_ADMIN">
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="dashboard/search-hotel" element={<AdminSearchHotel />} />
            <Route path="dashboard/searchhotel" element={<AdminSearchHotel />} />
            <Route path="dashboard/account-manager" element={<AdminAgentsManagement />} />
            <Route path="dashboard/account-manager/details/:id" element={<AdminAgentDetails />} />
            <Route path="dashboard/support-manager" element={<AdminSupportManagement />} />
            <Route path="dashboard/support-manager/details/:id" element={<AdminSupportDetails />} />
            <Route path="dashboard/agent-tickets" element={<AdminAgentTickets />} />
            <Route path="dashboard/support-tickets" element={<AdminSupportTickets />} />
            <Route path="dashboard/support-tickets/:ticketId" element={<AdminSupportTicketDetails />} />
            <Route path="dashboard/admin-assigned-tickets" element={<AdminMySupportTickets />} />
            <Route path="dashboard/admin-assigned-tickets/:ticketId" element={<AdminMySupportTicketDetails />} />
            <Route path="dashboard/token-recharge-page" element={<AdminAgentTokenRecharge />} />
            <Route path="dashboard/agent-token-recharge" element={<AdminAgentTokenRecharge />} />
            <Route path="dashboard/agent-token-recharge/:agentId/recharge" element={<AdminTokenRechargeOperation />} />
            <Route path="dashboard/agent-token-recharge/:agentId/booking-history" element={<AdminAgentBookingHistory />} />
            <Route path="dashboard/booking-details" element={<AdminBookingDetails />} />
            <Route path="dashboard/booking-details/:bookingId" element={<AdminBookingDetailView />} />
            <Route path="dashboard/cancellation-booking" element={<AdminCancellationBooking />} />
            <Route path="dashboard/cancellation-booking/:cancellationId" element={<AdminCancellationBookingDetails />} />
            <Route path="dashboard/cancellation-page-details" element={<AdminCancellationBooking />} />
            <Route path="dashboard/payment-info" element={<AdminPaymentInfo />} />
            <Route path="dashboard/payment-info/:agentId" element={<AdminPaymentInfoDetails />} />
            <Route path="dashboard/manual-payment-info" element={<AdminManualPaymentInfo />} />
            <Route path="dashboard/manual-payment-info/:ticketId" element={<AdminManualPaymentDetails />} />
            <Route path="dashboard/payment-refund-info" element={<AdminPaymentRefundInfo />} />
            <Route path="dashboard/payment-refund-info/:agentId" element={<AdminPaymentRefundInfoDetails />} />
            <Route path="dashboard/settings" element={<AdminSettings />} />
            <Route path="dashboard/settings/api-manager" element={<AdminApiManager />} />
            <Route path="dashboard/settings/platform" element={<AdminPlatformSettings />} />
            <Route path="dashboard/settings/cancellation-policy" element={<AdminCancellationPolicySettings />} />
            <Route path="dashboard/settings/add-support-executive" element={<AdminAddSupportExecutive />} />
          </Route>

          {/* Generic Dashboard (will redirect to role-specific) */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />

          {/* Catch-all - redirect to home instead of login */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </Router>
  );
}

export default App;